import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
// import { useRouter } from "vue-router";

// const router = useRouter();


export default /*#__PURE__*/_defineComponent({
  __name: 'SetToken',
  props: {
  token: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



onMounted(async () => {
  const token = props.token;
  if (token) {
    // await store.dispatch(Actions.LOGOUT);
    window.localStorage.clear();

    localStorage.setItem("jwt_token", JSON.stringify({ access_token: token }));
    localStorage.setItem("id_token", token);
    // router.push({ name: "dashboard" });
    window.location.href = "/portal";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!

  return (_openBlock(), _createBlock(_component_LoadingRing))
}
}

})